import { useState } from 'react';

type Size = 'sm' | 'md' | 'lg';

/* Fixed pixel boxes, not percentages. A browse list of 4,800 rows whose images
   arrive at unpredictable moments will jump under the reader's thumb unless
   every slot is the right size before anything has loaded. */
const DIMENSIONS: Record<Size, { w: number; h: number; request: number }> = {
  sm: { w: 56, h: 56, request: 160 },
  md: { w: 96, h: 72, request: 320 },
  lg: { w: 200, h: 150, request: 640 },
};

type Props = {
  id: number;
  title: string;
  size?: Size;
};

/** The cover photo off a recipe card.

    Not every card renders — a handful are missing from the corpus mount and
    one style is a flattened scan — so a missing image has to be a normal
    outcome with a real appearance, not a broken-image icon. */
export default function RecipeThumb({ id, title, size = 'sm' }: Props) {
  const [failed, setFailed] = useState(false);
  const { w, h, request } = DIMENSIONS[size];

  if (failed) {
    return (
      <span
        className={`thumb thumb--${size} thumb--placeholder`}
        style={{ width: w, height: h }}
        aria-hidden="true"
      >
        {title.trim().charAt(0).toUpperCase() || '?'}
      </span>
    );
  }

  return (
    <img
      className={`thumb thumb--${size}`}
      src={`/api/recipes/${id}/thumb/?w=${request}`}
      width={w}
      height={h}
      loading="lazy"
      decoding="async"
      alt=""
      onError={() => setFailed(true)}
    />
  );
}
